import {inject, Injectable} from "@angular/core";
import {AssessableContextService} from "./assessment-context.service";
import {AssessableUiService} from "./assessable-ui.service";

/**
 * This services responsibility is to handle operations that modify the state of the assessment and in response trigger something in the ui.
 */
@Injectable()
export class AssessableProxyService {
	// explicitly not typed this should be `Assessable` agnostic
	private _contextService = inject(AssessableContextService);
	private _uiService = inject(AssessableUiService);

	public async addGroup() {
		const id = await this._contextService.addGroup();
		this._uiService.scrollAndEditGroup(id);
	}

	public async addItemToGroup(groupIndex: number) {
		const {groupId, itemId} = await this._contextService.addItemToGroup(groupIndex);
		this._uiService.scrollAndEditItem(groupId, itemId);
	}

	public removeGroup(groupId: string, groupIndex: number) {
		this._contextService.removeGroup(groupIndex);
		if (groupId === this._uiService.groupInEditMode()) {
			this._uiService.toggleGroupEditMode(groupId);
		}
	}
}
